export function isAdmin(to, from, next) {
  let role = localStorage.getItem("role");
  if (role != "super_admin") {
    return next();
  }
  let path = getPath(role);
  return next(path);
}
export function isFunder(to, from, next) {
  let account_type = localStorage.getItem("account_type");
  let role = localStorage.getItem("role");
  if (account_type === "funder" && role != "super_admin") {
    return next();
  }
  let path = getPath(role);
  return next(path);
}

export function isAuditor(to, from, next) {
  let account_type = localStorage.getItem("account_type");
  if (account_type === "auditor") {
    return next();
  }
  return next(path);
}

export function isSuperAdmin(to, from, next) {
  let role = localStorage.getItem("role");
  if (role === "super_admin") {
    return next();
  }

  let path = getPath(role);
  return next(path);
}
export function isAnchor(to, from, next) {
  let account_type = localStorage.getItem("account_type");
  let role = localStorage.getItem("role");
  if (account_type === "anchor" && role != "super_admin") {
    return next();
  }

  let path = getPath(role);
  return next(path);
}
export function isPasswordReset(to, from, next) {
  let reset = localStorage.getItem("reset_password");
  if (reset == 0) {
    return next();
  }

  // return next("/admin/password/reset");
  let account_type = localStorage.getItem("account_type");
  if (account_type === "supplier") {
    return next("/supplier/password/reset");
  } else if (account_type === "funder") {
    return next("/funder/password/reset");
  } else {
    return next("/anchor/password/reset");
  }
}

function getPath(role) {
  if (role === "super_admin") {
    return "super-admin/dashboard";
  } else {
    // return 'admin/dashboard'
    return "supplier/dashboard";
  }
}
